var isPassiveEventSupported = (function () {
    var isSupported = false;
    try {
        window.addEventListener('passive', function () { }, {
            get passive() {
                // eslint-disable-next-line no-return-assign
                return (isSupported = true);
            }
        });
    }
    catch (err) {
        //
    }
    return function () { return isSupported; };
})();
/* eslint-disable prettier/prettier */
var coerceEventOptions = function (options) {
    var passive = isPassiveEventSupported();
    return passive
        ? options
        : Boolean(typeof options === 'object' ? options.capture : options);
};
export function on(el, event, func, options) {
    el.addEventListener(event, func, coerceEventOptions(options));
}
export function off(el, event, func, options) {
    el.removeEventListener(event, func, coerceEventOptions(options));
}
